import React from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import classNames from 'classnames';

import Colours from '../definitions/Colours';
import MessagePropType from '../definitions/MessagePropType';
import messageToString from '../functions/messageToString';


function PillCaption({
    backgroundColour = Colours.STONE_LIGHT,
    colour = Colours.BLACKBERRY,
    message,
    className,
    ...otherProps
}) {
    const intl = useIntl();

    return (
        <Container
            className={classNames(className, 'rh-text-xs', 'rh-px-0_75', 'rh-width-fit-content', 'rh-text-align-center', 'rh-border-radius-4px')}
            backgroundColour={backgroundColour}
            colour={colour}
            {...otherProps}
        >
            {messageToString(message, intl)}
        </Container>
    );
}

PillCaption.propTypes = {
    backgroundColour: PropTypes.oneOf(Object.values(Colours)),
    colour: PropTypes.oneOf(Object.values(Colours)),
    message: MessagePropType.isRequired,
    className: PropTypes.string,
};


const Container = styled.div`
    color: ${props => props.colour};
    background-color: ${props => props.backgroundColour};
`;

export default PillCaption;
